import React, { useState, useEffect } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
  Paper,
  AppBar,
  Breadcrumbs,
  IconButton,
} from "@mui/material";
import { useInnoflexApiClient } from "../Services/api/InnoFlexService";
import { useNavigate, useParams } from "react-router-dom";
import { Link } from "@mui/material"
import { BorderLeft, Home } from "@mui/icons-material";
import { useAppContext } from "../../hooks/context/AppContext";
import "../../pages/home.css";
import Grid from "@mui/material/Grid2";
import { projectVersion } from "config/navConfig";



interface InnoflexPhase {
  InnoflexPhase_key: number;
  InnoflexPhasevalue: string;
  InnoflexPhasedescription: string;
}

interface PhaseOption {
  Innoflex_Phase_Options_Key: number;
  Milestone: string;
}

const InnoflexPhasePage: React.FC = () => {
  const [phases, setPhases] = useState<InnoflexPhase[]>([]);
  const [activePhase, setActivePhase] = useState<number | null>(2); // Default to "Explore"
  const [milestonesFromPhase, setMilestonesFromPhase] = useState<PhaseOption[]>([]);
  interface InnoflexFile {
    FileName: string;
    FileUrl: string;
    // add other properties if needed
  }
  const [innoflexFile, setInnoflexFile] = useState<InnoflexFile | null>(null); 
  const navigate = useNavigate();
  const { appData, updateAppData } = useAppContext();
  const { getInnoflexPhases, getInnoflexPhaseOptions, getInnoflexFile } = useInnoflexApiClient();

  useEffect(() => {
    const fetchPhases = async () => {
      try {
        const response = await getInnoflexPhases();
        setPhases(response);
        if (response?.length > 0) {
          fetchPhaseMilestones(2); // Load "Explore" by default
        }
      } catch (error) {
        console.error("Error fetching Innoflex phases:", error);
      }
    };

    fetchPhases();
    fetchInnoflexFile();
  }, []);

  const fetchPhaseMilestones = async (phaseKey: number) => {
    try {
      const response = await getInnoflexPhaseOptions(phaseKey);
      setMilestonesFromPhase(response?.data || []);
    } catch (error) {
      console.error(`Error fetching milestones for phase ${phaseKey}:`, error);
    }
  };

  const handlePhaseChange = (phaseKey: number) => {
    setActivePhase(phaseKey);
    fetchPhaseMilestones(phaseKey);
  };
  let handleHomeClick = () => {
    if (!appData.isFormChanged) {
      navigate(`${projectVersion}/projects-grid`)
    } else {
      updateAppData({ isFormChanged: true, showUnSavedModal: true, url: '/projects-grid' });
    }
  }
  let handleLandingClick = () => {
    if (!appData.isFormChanged) {
      navigate(`${projectVersion}/`);
    } else {
      updateAppData({ isFormChanged: true, showUnSavedModal: true, url: `/` });
    }
  }
  const fetchInnoflexFile = async () => {
    try {
      const response = await getInnoflexFile();
      setInnoflexFile(response?.data || []);  
    } catch (error) {
      console.error(`Error fetching Innoflex File`, error);
    }
  };
  console.log("innoflexFile",innoflexFile);

  return (
    <AppBar position="static" sx={{ backgroundColor: "transparent", boxShadow: "none", padding: "10px" }}>
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
        {/* Top Navigation Bar */}
        <Box className="breadcrumb-container" sx={{ mb: 1 }}> {/* Adjust mb to your liking */}
          <Breadcrumbs aria-label="breadcrumb">
            <IconButton onClick={handleLandingClick} sx={{ color: "#003399" }}>
              <Home fontSize="medium" />
            </IconButton>
            <Link
              underline="hover"
              color="inherit"
              onClick={handleHomeClick}
              sx={{ fontSize: "13px" }}
            >
              Back to List
            </Link>
          </Breadcrumbs>
        </Box>

      </Box>
      <Box sx={{ p: 1 }}>
        <div className="innoflex-help">
          <Grid container spacing={2} mt={2}>
            <Grid size={8}>
              <Typography variant="h6" sx={{ color: "#0033CC", fontWeight: 600, mb: 2, mt: 0 }} >
                Innoflex Phase
              </Typography>
              <hr></hr>
              <br></br>
              {/* Dynamic Phase Tabs */}
              <Box sx={{ display: "flex", gap: 1, mb: 3 }}>
                {phases.map((phase) => (
                  <Button
                    key={phase.InnoflexPhase_key}
                    variant={activePhase === phase.InnoflexPhase_key ? "contained" : "outlined"}
                    sx={{
                      textTransform: "none",
                      borderRadius: "20px",
                      fontSize: 12,
                      padding: "4px 16px",
                      backgroundColor: activePhase === phase.InnoflexPhase_key ? "#0033CC" : "#fff",
                      color: activePhase === phase.InnoflexPhase_key ? "#fff" : "#0033CC",
                      borderColor: "#0033CC",
                      "&:hover": {
                        backgroundColor: activePhase === phase.InnoflexPhase_key ? "#002299" : "#f0f0f0",
                      },
                    }}
                    onClick={() => handlePhaseChange(phase.InnoflexPhase_key)}
                  >
                    {phase.InnoflexPhasevalue}
                  </Button>
                ))}
              </Box>

              {/* Milestone Table */}
              <TableContainer component={Paper}>
                <Table size="small">
                  <TableHead sx={{ backgroundColor: "#f5f5f5" }}>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 600 }}>S.No</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Milestones</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {milestonesFromPhase.length > 0 ? (
                      milestonesFromPhase.map((item, index) => (
                        <TableRow key={item.Innoflex_Phase_Options_Key}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{item.Milestone}</TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={2} align="center">
                          No Milestones
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            
            <Grid size={4} spacing={2} mt={2}>
              <div className="upload-btn">
                  <Typography variant="h6" sx={{ color: "#0033CC", fontWeight: 600, mb: 2, mt: 0 }} >
                  Innoflex Document
                </Typography>
              </div>
              <div className="clearboth"></div>
              <hr></hr>
              <br></br>
              <div className="upload-docs">
              <Grid container spacing={0} mt={0}>
                <Grid size={9}>
                 <a
                    href={innoflexFile?.FileUrl ? innoflexFile.FileUrl : "#"}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#0033CC", textDecoration: "none" }}
                  >
                    {innoflexFile?.FileName ? innoflexFile.FileName : "No Document Available"}
                  </a>              
                </Grid>
                {/* <Grid size={3}>
                  <span>Download</span>
                  <span>Remove</span>
                </Grid> */}
              </Grid>
            </div>
            </Grid>
           
          </Grid>
        </div>
      </Box>
    </AppBar>

  );
};

export default InnoflexPhasePage;
